import { styled } from '../../../stitches.config';

export const TextArea = styled('textarea', {
  'display': 'block',
  'width': '100%',
  'padding': '$5',
  'borderWidth': '3px',
  'borderStyle': 'solid',
  'borderColor': '$purple5',
  'borderRadius': '$medium',
  'fontSize': '$3',
  '&:hover': {
    borderColor: '$purple6',
  },
  '&:focus, &:focus-visible': {
    borderColor: '$purple7',
    outline: 'none',
  },
  'variants': {
    large: {
      true: {
        padding: '$2 $3',
        fontSize: '$3',
      },
    },
    minimal: {
      true: {
        backgroundColor: 'transparent',
        border: 'none',
      },
    },
    active: {
      true: {
        backgroundColor: '$gray6',
      },
    },
    intent: {
      none: {
        backgroundColor: 'white',
      },
      primary: {
        backgroundColor: '&gray8',
      },
    },
    fullWidth: {
      true: {
        width: '100%',
      },
    },
    isError: {
      true: {
        borderColor: '$red6',
        color: '$red11',
        backgroundColor: '$red1',
      },
    },
  },
});
